import { z } from 'zod';

import { PeoCompanyType, SignUpMethod } from 'src/api';

import { PeoSettingsFormFields, PeoSettingsFormValues } from '../types';

export const peoSettingsFormValidationSchema = z.object({
  [PeoSettingsFormFields.companyType]: z.enum(PeoCompanyType),
  [PeoSettingsFormFields.signUpMethod]: z.enum(SignUpMethod),
  [PeoSettingsFormFields.pinHint]: z
    .string()
    .max(200, 'PIN Hint must be at most 200 characters')
    .nullish(),
}) satisfies z.ZodType<PeoSettingsFormValues>;
